export enum ApartmentPriceTableColumn {
	Location = 1,
	Apartment = 2,
	Floor = 3,
	Layout = 4,
	Amenities = 5,
	FloorArea = 6,
	AmenitiesArea = 7,
	FloorAreaPrice = 8,
	PackagePrice = 9,
	TotalPrice = 10,
	CompletionDate = 11,
	Orientation = 12,
	SpecialEquipment = 13,
	State = 14,
	Favorite = 15,
	FinalDiscount = 16,
	Bonus = 17 /* Nový sloupec Dárek v ceníkové tabulce/vyhledávání (Požadavek #31650) */
}
